// deps
import React, { ReactElement, memo } from "react";
import classNames from "classnames";

// styles
import styles from "./LoadingScreen.scss";
import { withStyles } from "@swiggy-private/core-ui";

// components
import CircleLoader from "@payment-ui/widgets/circle-loader";

// test-ids
import { LOADING_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface LoadingScreenProps {
    className?: string;
}

function LoadingScreen(props: LoadingScreenProps): ReactElement {
    const containerClass = classNames(styles.container, props.className);

    return (
        <div className={containerClass} data-testid={LOADING_SCREEN_TEST_IDS.CONTAINER}>
            <CircleLoader size="large" data-testid={LOADING_SCREEN_TEST_IDS.CIRCLE_LOADER} />
        </div>
    );
}

export default memo(withStyles<LoadingScreenProps>(LoadingScreen, styles));
